// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__39-rZ","buttons":"styles_buttons__1ZnkF"};